<template>
  <div>
    <!-- 顶部导航 -->
    <m-header :memberState="memberState"></m-header>
    <!-- 外层wrap -->
    <div class="memberWrap">
      <!-- 版心 -->
      <div class="memberBox">
        <!-- 头部 -->
        <header class="memberHeader">
          <div class="memberTitle">
            <h1>CG搜模网VIP</h1>
            <h2>欢迎加入我们的会员</h2>
            <span>成为我们的会员，享受专属特权和丰富的资源。</span>
          </div>
        </header>
        <!-- 会员价格区域 -->
        <div class="memberPrice">
          <div class="priceTitle">
            <h1>会员价格</h1>
            <p>我们提供多种会员价位，以满足不同用户的需求。</p>
          </div>
          <div class="priceList">
            <div class="priceItem" @mouseover="mouseover(index)" @mouseout="mouseout"
              :class="{ 'active': activeFlag === index }" v-for="(item, index) in priceData" :key="item.id">
              <div class="vipType">{{ item.vipType }}VIP</div>
              <div class="vipPrice">¥{{ item.vipPrice }}/{{ item.vipDate }}</div>
              <div class="vipDesc">
                <div class="descItem">
                  <img v-if="activeFlag === index" src="@/assets/member/checkedAct.png" alt="">
                  <img v-else src="@/assets/member/checked.png" alt="">
                  <span>赠送{{ item.points }}积分</span>
                </div>
                <div class="descItem">
                  <img v-if="activeFlag === index" src="@/assets/member/checkedAct.png" alt="">
                  <img v-else src="@/assets/member/checked.png" alt="">
                  <span v-if="item.type === 3">免费模型下载无限制</span>
                  <span v-else>免费模型下载{{ item.freeModelNum }}个/天</span>

                </div>
                <div class="descItem">
                  <img v-if="activeFlag === index" src="@/assets/member/checkedAct.png" alt="">
                  <img v-else src="@/assets/member/checked.png" alt="">
                  <span v-if="item.type === 3">会员模型免费下载无限制</span>
                  <span v-else>会员模型免费下载{{ item.memberModelNum }}个/天</span>
                </div>
                <div class="descItem">
                  <img v-if="activeFlag === index" src="@/assets/member/checkedAct.png" alt="">
                  <img v-else src="@/assets/member/checked.png" alt="">
                  <span>付费模型{{ item.paymentModel }}折</span>
                </div>
              </div>
              <el-button class="buyNowBtn" @click="buyNowBtn(item.type)">立即购买</el-button>
            </div>
          </div>

        </div>
        <!-- VIP会员权益 -->
        <div class="vipMemberRight">
          <div class="priceTitle">
            <h1>VIP会员权益</h1>
            <p>选择适合您的会员套餐</p>
          </div>
          <div class="memberRightBottom">
            <ul class="memRightType">
              <li v-for="(item, index) in memRightType" :key="index">{{ item }}</li>
            </ul>
            <ul class="ordinaryUser" @mouseover="mouseoverMemUser(0)" @mouseout="mouseoutMemberRight"
              :class="{ 'act': actFlag === 0 }">
              <li v-for="(item, index) in ordinaryUser" :key="index">{{ item }}</li>
            </ul>
            <div class="vipMemberWrap">
              <ul class="vipMemberList" v-for="item in memberRigPriData" :key="item.id"
                @mouseover="mouseoverMemberRight(item.type)" @mouseout="mouseoutMemberRight"
                :class="{ 'act': actFlag === item.type }">
                <li>{{ item.vipType }}VIP</li>
                <li>{{ item.vipPrice }}元/{{ item.vipDate }}</li>
                <li v-if="item.freeModelNum == '无限制'">无限制</li>
                <li v-else>{{ item.freeModelNum }}个/天</li>
                <li>
                  {{ item.memberModelNum }}
                </li>
                <li>{{ item.paymentModel }}折</li>
                <li>
                  <img v-if="actFlag === item.type" src="@/assets/member/check_2.png" alt="">
                  <img v-else src="@/assets/member/check_1.png" alt="">
                </li>
                <li>
                  <img v-if="actFlag === item.type" src="@/assets/member/check_2.png" alt="">
                  <img v-else src="@/assets/member/check_1.png" alt="">
                </li>
                <li>
                  <img v-if="actFlag === item.type" src="@/assets/member/check_2.png" alt="">
                  <img v-else src="@/assets/member/check_1.png" alt="">
                </li>
                <li>{{ item.points }}积分</li>
                <li>极速下载</li>
              </ul>
            </div>
          </div>
        </div>

        <!-- 会员特权 -->
        <div class="MembershipPiv">
          <div class="MembershipPivTitle">
            <h1>会员特权</h1>
            <p>成为本站会员，您将享受到以下特权：</p>
          </div>
          <div class="MembershipType">
            <ul>
              <li v-for="(item, index) in MembershipType" :key="index">
                <div class="MembershipPic">
                  <img :src="item.url" alt="">
                </div>
                <p class="MembershipName">{{ item.name }}</p>
                <p class="MembershipValue">{{ item.value }}</p>
              </li>
            </ul>
          </div>
        </div>

        <!-- 会员开通专区 -->
        <div class="MembershipArea">
          <div class="memberShipAreaModel">
            <div class="memberShipAreaModelTitle">
              <span class="ipt"><img src="@/assets/member/arrowUp.png" alt=""></span>
              <span class="txt">VIP模型专区</span>
            </div>
            <p>VIP会员专区模型免费下载</p>
            <p>不同套餐特权不同，选择适合您的</p>
            <p>最高会员专区无限下载</p>
            <p>会员专区模型不限速下载</p>
            <div class="OpenImmediae" @click="OpenImmedMember">
              立即开通 <span>></span>
            </div>
          </div>
          <div class="memberShipAreaModel">
            <div class="memberShipAreaModelTitle">
              <span class="ipt1"><img src="@/assets/member/dableMem.png" alt=""></span>
              <span class="txt">会员双倍积分</span>
            </div>
            <p>会员每日登录就送双倍积分</p>
            <p>会员充值积分9.5折</p>
            <p>开通会员就送海量积分</p>
            <div style="margin-top: 65px;" class="OpenImmediae" @click="OpenImmedMember">
              立即开通 <span>></span>
            </div>
          </div>
          <div class="memberShipAreaModel">
            <div class="memberShipAreaModelTitle">
              <span class="ipt"><img src="@/assets/member/star.png" alt=""></span>
              <span class="txt">免费模型下载</span>
            </div>
            <p>最高免费模型不限量下载</p>
            <p>会员专享极速下载</p>
            <p>会员购买搜币模型享折扣</p>
            <p>专享客服</p>
            <div class="OpenImmediae" @click="OpenImmedMember">
              立即开通 <span>></span>
            </div>
          </div>
        </div>

        <!-- 帮助中心 -->
        <div class="helpCenter">
          <div class="helpCenterTitle">
            <h1>帮助中心</h1>
            <p>这里放常见问答</p>
          </div>
          <div class="helpCenterContentTitle">
            有任何问题，请随时联系我们。
          </div>
          <div class="helpCenterContent">
            <div v-clickoutside="handleClickontactUs" class="code" v-if="ishidden">
              <img src="@/assets/link.png" alt="">
              <p>
                扫码联系客服
              </p>
            </div>
            <div @click="contactUs" class="helpCenterContentBox">
              <div class="ipt"><img src="@/assets/member/contactUs.png" alt=""></div>
              <p>联系我们</p>
            </div>
            <div v-clickoutside="handleClickation" class="code_1" v-if="ishiddation">
              <img src="@/assets/link.png" alt="">
              <p>
                扫码联系客服
              </p>
            </div>
            <div @click="cooperation" class="helpCenterContentBox">
              <div class="ipt"><img src="@/assets/member/cooperation.png" alt=""></div>
              <p>商务合作</p>
            </div>

            <div @click="earnPoints" class="helpCenterContentBox">
              <div class="ipt"><img src="@/assets/member/earnPoints.png" alt=""></div>
              <p>赚取积分</p>
            </div>
            <div @click="problemFn" class="helpCenterContentBox">
              <div class="ipt"><img src="@/assets/member/Q&A.png" alt=""></div>
              <p>常见问题</p>
            </div>
          </div>
        </div>

        <!-- 常见问题 -->
        <div ref="targetLocation" class="usualQuest">
          <div class="usualQuestTitle">
            <h1>常见问题</h1>
            <p>Q & A</p>
          </div>
          <div class="usualQuestContent">
            <p>1.开通会员可以下载全部模型吗？</p>
            <p>A：开通对应会员享受对应权益，比如开通钻石VIP可以下载会员专区模型和免费模型，积分模型和搜币模型还是需要扣除相应的货币。</p>
            <p>2.开通会员可以开发票吗？</p>
            <p>A：开通会员需金额满100及以上才可以开发票，发票种类为：普通纸质发票，开票类型：设计服务费，具体开票细节请联系客服，开发票请用微信支付。</p>
            <p>3.开通会员就送相应积分吗？</p>
            <p>A：对的，开通一年黄金VIP送5000积分，开通两年送12000积分（多送2000积分），开通三年送18000积分（多送3000积分）。</p>
            <p>4.积分会过期吗？</p>
            <p>A：积分不会过期，用完为止。</p>
            <p>5.积分可以单独充值吗？</p>
            <p>A:积分可以单独充值，请跳转到我们<a @click="pointRecharge">积分充值</a>。</p>
            <p>6.积分还有其他获取渠道吗？</p>
            <p>A:有的，上传模型经过审核以及每日登录都会送积分的。</p>
            <p>7.购买的会员可以退款吗？</p>
            <p>A：不支持退款，请理性消费，谨慎购买。</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 会员充值弹窗 -->
    <openMembership @memberHidden="memberHidden" v-if="isVisible" :memberType="memberType" @changeMemType="changeMemType"
      @isBuySuccess="isBuySuccess">
    </openMembership>
    <!-- 积分充值弹窗 -->
    <openPointRecharge v-if="isHidden" @hiddenPoints="hiddenPoints" @changeMemType="changeMemType"
      @isBuySuccess="isBuySuccess"></openPointRecharge>
    <successRechart :onceNum="onceNum" :isvisib="isvisib" @isBuySuccess="isBuySuccess"></successRechart>
  </div>
</template>

<script>
import openMembership from '@/components/openMembership/index.vue'
import openPointRecharge from '@/components/openPointRecharge/index.vue'
import successRechart from '@/components/successRechart/index.vue'
import Clickoutside from 'element-ui/src/utils/clickoutside'
import {
  myAccountApi
} from "@/api/user";
export default {
  directives: { Clickoutside },
  name: 'memberLogined',
  components: {
    openMembership,
    openPointRecharge,
    successRechart
  },
  data () {
    return {
      priceData: [ // 会员价格列表
        {
          id: 1,
          type: 1,
          vipType: '白银',
          vipPrice: 29,
          vipDate: '月',
          points: 600,
          freeModelNum: 10,
          memberModelNum: 5,
          paymentModel: 9.8
        },
        {
          id: 2,
          type: 2,
          vipType: '黄金',
          vipPrice: 199,
          vipDate: '年',
          points: 5000,
          freeModelNum: 50,
          memberModelNum: 30,
          paymentModel: 9.5
        },
        {
          id: 3,
          type: 3,
          vipType: '钻石',
          vipPrice: 399,
          vipDate: '年',
          points: 10000,
          freeModelNum: "无限制",
          memberModelNum: "无限制",
          paymentModel: 9.5
        }
      ],
      memberRigPriData: [
        {
          id: 2,
          type: 2,
          vipType: '黄金',
          vipPrice: 199,
          vipDate: '年',
          points: 5000,
          freeModelNum: 50,
          memberModelNum: '30个/天',
          paymentModel: 9.5
        },
        {
          id: 1,
          type: 1,
          vipType: '白银',
          vipPrice: 29,
          vipDate: '月',
          points: 600,
          freeModelNum: 10,
          memberModelNum: '5个/天',
          paymentModel: 9.8
        },
        {
          id: 3,
          type: 3,
          vipType: '钻石',
          vipPrice: 399,
          vipDate: '年',
          points: 10000,
          freeModelNum: "无限制",
          memberModelNum: "无限制",
          paymentModel: 9.5
        }
      ],
      activeFlag: null, // 鼠标悬浮会员价格高亮
      actFlag: 2, // 鼠标悬浮会员权益高亮
      memRightType: ['', '专享高品质3D模型下载', '免费模型下载特权', '会员免费专区', '折扣特权', '登录享双倍积分', '活动特权', '专享服务', '附赠积分', '下载特权'],
      ordinaryUser: ['普通用户', '', '5个/天', '', '', '', '', '', '', '200KB/S'],
      MembershipType: [
        {
          url: require('../assets/member/MemberHorGe.png'),
          name: '会员尊贵标识',
          value: '专属会员标识'
        },
        {
          url: require('../assets/member/MemberPrice.png'),
          name: '会员价格',
          value: '以优惠的价格购买模型，尽享更多高质量3D模型'
        },
        {
          url: require('../assets/member/IntegralEquity.png'),
          name: '积分权益',
          value: '开通会员享海量积分'
        },
        {
          url: require('../assets/member/FreeMembers.png'),
          name: '会员免费专区',
          value: '会员专区模型下载特权，让您专注于作品创作'
        },
        {
          url: require('../assets/member/LoginDoublepoint.png'),
          name: '登录双倍积分',
          value: '会员每日登录享双倍积分'
        },
        {
          url: require('../assets/member/ActivityPriv.png'),
          name: '活动特权',
          value: '会员将有机会参与各种专属活动，赢取丰厚奖品'
        },
        {
          url: require('../assets/member/ExclusiveService.png'),
          name: '专享服务',
          value: '会员享受一对一专属客服服务，更快速解决问题'
        },
        {
          url: require('../assets/member/MorePriv.png'),
          name: '更多特权',
          value: '会员还将享受更多特权，敬请期待'
        }
      ],
      memberType: null,
      isVisible: false,
      isHidden: false, // 积分组件显示隐藏
      ishidden: false, // 联系我们
      ishiddation: false, // 商务合作
      isvisib: false,
      onceNum: null,
      memberState: null
    }
  },
  mounted () {
    myAccountApi().then(res => {
      if (res.code === 200) {
        this.memberState = res.data.memberState
        localStorage.setItem('memberState', res.data.memberState)
      }
    })
  },
  methods: {
    /**
     * @description   注册
     */
    signFn () {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          // 表单验证通过， 可以提交
        } else {
          // 表单验证失败， 阻止提交
          return false;
        }
      })
    },
    /**
     * @desc 鼠标移入/移出 会员价格盒子高亮
     */
    mouseover (index) {
      this.activeFlag = index
    },
    mouseout () {
      this.activeFlag = null
    },
    /**
     * @desc 鼠标移入/移出 会员权益盒子高亮
     */
    mouseoverMemberRight (type) {
      this.actFlag = type
    },
    mouseoutMemberRight () {
      this.actFlag = 2
    },
    mouseoverMemUser (type) {
      this.actFlag = type
    },
    /**
    * @点击立即购买
    */
    buyNowBtn (type) {
      this.memberType = type
      this.isVisible = true
    },
    /**
     * @点击会员充值组件之外的区域 组件消失
     */
    handleClickOutside () {
      this.isVisible = false
    },
    /**
     * @desc 点击立即开通按钮
     */
    OpenImmedMember () {
      this.memberType = 2;
      this.isVisible = true
    },
    /**
    * @desc 积分充值
    */
    pointRecharge () {
      this.isHidden = true
    },

    /**
     * @desc 联系我们
     */
    contactUs () {
      this.ishidden = true
    },
    handleClickontactUs () {
      this.ishidden = false
    },
    /**
     * @desc 商务合作
     */
    cooperation () {
      this.ishiddation = true
    },
    handleClickation () {
      this.ishiddation = false
    },
    /**
     * @desc 赚取积分
     */
    earnPoints () {
      this.$router.push('/user/resource')
    },
    /**
     * @desc 常见问题
     */
    problemFn () {
      const targetLocation = this.$refs.targetLocation;
      targetLocation.scrollIntoView();
    },
    changeIshiddenState (state) {
      this.isHidden = state
      this.isVisible = false
    },
    hiddenPoints (val) {
      this.isHidden = val
    },
    memberHidden (val) {
      this.isVisible = val
    },
    isBuySuccess (val) {
      this.isvisib = val
    },
    chageisvisib (val) {
      this.isvisib = val
    },
    changeMemType (val) {
      this.onceNum = val
    }


  },
}
</script>

<style lang="less" scoped>
.memberWrap {
  width: 100vw;
  background-color: rgb(29 33 41);
  overflow-x: auto;
  user-select: none;

  .memberBox {
    width: 100vw;
    margin: auto;

    .memberHeader {
      height: 900px;
      background-image: url("../assets/member/headerBgLogined.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position-y: center;
      display: flex;
      justify-content: center;
      align-items: center;

      .memberTitle {
        width: 550px;
        height: 100px;
        text-align: center;
        line-height: 80px;
        user-select: none;
        color: rgb(255, 255, 255);
        margin-left: -100px;

        h1 {
          font-size: 5.5rem;
          font-weight: 700;
          margin-left: -500px;
          margin-top: -100px;
        }

        h2 {
          font-size: 3rem;
          font-weight: 700;
          margin-left: -500px;
          margin-top: 50px;
        }

        span {
          font-size: 1.2rem;
          font-weight: 500;
          margin-left: -500px;
        }
      }

      .loginForm {
        width: 550px;
        height: 550px;
        background-color: rgb(18, 18, 18);
        border-radius: 1.5rem;
        border: 1px solid #e0b58c;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        color: aliceblue;
        margin-left: 80px;

        h1 {
          font-size: 3.5rem;
          font-weight: 700;
          margin-left: -35px;
        }

        p {
          font-size: 1.125rem;
          font-weight: 400;
          margin-top: -3rem;
          margin-left: -30px;
        }

        .form {
          position: relative;
          top: -30px;

          .formItem {
            width: 400px;
          }

          .btn {
            position: absolute;
            top: 20px;
            width: 400px;
            height: 50px;
            background-color: #ff9900;
            border: none;
            color: #000;
            border-radius: 0.8rem;
            font-size: 20px;
            cursor: pointer;
          }
        }

        .ExistingAccount {
          cursor: pointer;
        }
      }
    }

    .memberPrice {
      height: 900px;
      background-color: rgb(29 33 41);
      display: flex;
      flex-direction: column;
      align-items: center;

      .priceTitle {
        h1 {
          font-size: 3rem;
          font-weight: 700;
          color: aliceblue;
          margin-top: 80px;
          text-align: center;
        }

        p {
          font-size: 1.125rem;
          font-weight: 400;
          color: aliceblue;
          margin-top: 30px;
          text-align: center;
        }
      }

      .priceList {
        position: relative;
        top: 60px;
        display: flex;
        flex-direction: row;

        .priceItem {
          margin: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          align-items: center;
          width: 400px;
          height: 514px;
          background-color: #ffffff14;
          border-radius: 1.5rem;

          .vipType {
            position: absolute;
            top: 50px;
            color: #ffffff99;
            font-size: 1.25rem;
            font-weight: 700;
          }

          .vipPrice {
            position: absolute;
            top: 100px;
            color: #fff;
            font-size: 2.5rem;
            font-weight: 700;
          }

          .vipDesc {
            position: absolute;
            top: 200px;

            .descItem {
              margin: 20px 0;
              color: #fff;
              font-size: 1rem;
              font-weight: 400;

              img {
                width: 7%;
                vertical-align: middle;
                margin-right: 10px;
                -webkit-user-drag: none;
              }
            }
          }

          .buyNowBtn {
            border: none;
            width: 300px;
            height: 3.25rem;
            position: absolute;
            bottom: 50px;
            border-radius: 2.5rem;
            background-color: rgb(255, 153, 0);
            color: #000;
            font-size: 1.2rem;
            font-weight: 500;
            cursor: pointer;
          }
        }

        .active {
          background-color: rgb(255, 153, 0);
          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
          transition: all 0.5s ease;
          transform: scale(1.1) translateY(-1.08rem);

          .vipType,
          .vipPrice,
          .vipDesc .descItem {
            color: #000;
          }

          .vipDesc .descItem img {
            -webkit-user-drag: none;
            color: #000;
          }

          .buyNowBtn {
            background-color: #ff26058c;
          }
        }
      }
    }

    .vipMemberRight {
      height: 900px;
      background-color: rgb(29 33 41);
      display: flex;
      flex-direction: column;
      align-items: center;

      .priceTitle {
        h1 {
          font-size: 3rem;
          font-weight: 700;
          color: aliceblue;
          text-align: center;
        }

        p {
          font-size: 1.125rem;
          font-weight: 500;
          color: aliceblue;
          margin-top: 30px;
          text-align: center;
        }
      }

      .memberRightBottom {
        user-select: none;
        width: 84rem;
        height: 35rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .memRightType {
          width: 26.25rem;
          height: 30rem;
          color: #fff;
          flex: 1;

          li {
            font-size: 1rem;
            font-weight: 500;
            width: 20rem;
            height: 4rem;
            background-color: #ffffff14;
            border-radius: 0.35rem;
            margin-bottom: 0.3rem;
            line-height: 4rem;
            padding-left: 1.5rem;
            box-sizing: border-box;
          }
        }

        .ordinaryUser {
          width: 26.25rem;
          height: 30rem;
          color: #fff;
          flex: 1;
          margin-left: 0.27rem;
          margin-right: -2rem;

          li {
            text-align: center;
            font-size: 1rem;
            font-weight: 500;
            width: 15rem;
            height: 4rem;
            line-height: 4rem;
            margin-bottom: 0.3rem;
            background-color: #ffffff14;
            border-radius: 0.35rem;
          }
        }

        .act {
          li {
            transition: all 0.2s ease;
            background-color: #ff9900;
            color: #000;
          }
        }

        .vipMemberWrap {
          width: 46rem;
          flex: 1;
          display: flex;
          margin-left: 0.27rem;

          .vipMemberList {
            flex: 1;
            width: 26.25rem;
            height: 30rem;
            color: #fff;
            margin-left: -2.4rem;

            li {
              text-align: center;
              font-size: 1rem;
              font-weight: 600;
              width: 15rem;
              height: 4rem;
              line-height: 4rem;
              margin-bottom: 0.3rem;
              background-color: #ffffff14;
              border-radius: 0.35rem;

              img {
                width: 10%;
                -webkit-user-drag: none;
              }
            }
          }

          .act {
            li {
              background-color: #ff9900;
              color: #000;
            }
          }
        }
      }
    }

    .MembershipPiv {
      width: 100%;
      height: 850px;
      background-color: rgb(29 33 41);
      display: flex;
      flex-direction: column;
      align-items: center;

      .MembershipPivTitle {
        margin-top: 55px;

        h1 {
          font-size: 3rem;
          font-weight: 700;
          color: aliceblue;
          text-align: center;
        }

        p {
          font-size: 1.125rem;
          font-weight: 500;
          color: aliceblue;
          margin-top: 30px;
          text-align: center;
          margin-bottom: 60px;
        }
      }

      .MembershipType {
        user-select: none;
        width: 84rem;
        height: 40rem;

        ul {
          text-align: center;
          width: 84rem;
          height: 40rem;
          color: #fff;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: space-around;

          li {
            width: 330px;
            height: 240px;

            .MembershipPic {
              width: 8rem;
              height: 8rem;
              line-height: 10rem;
              background-color: #000;
              border-radius: 50%;
              margin-left: 100px;
              margin-bottom: 30px;
            }

            .MembershipName {
              margin-left: 10px;
              font-size: 1.8rem;
              margin-bottom: 50px;
            }

            .MembershipValue {
              color: #ffffff99;
              font-size: 0.8rem;
              margin-left: 10px;
              margin-bottom: 150px;
            }
          }
        }
      }
    }

    .MembershipArea {
      width: 100%;
      height: 500px;
      background-color: rgb(29 33 41);
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      color: #ffffff;

      .memberShipAreaModel {
        width: 320px;
        height: 320px;
        background-color: #ffffff14;
        border-radius: 5%;
        margin: 0 10px;
        border: 1px solid #ffffff1a;

        .memberShipAreaModelTitle {
          padding-left: 30px;
          padding-top: 32px;
          box-sizing: border-box;
          margin-bottom: 25px;

          .ipt img {
            width: 16%;
            vertical-align: middle;
            margin-top: -8px;
            -webkit-user-drag: none;
          }

          .ipt1 img {
            width: 12%;
            vertical-align: middle;
            margin-top: -8px;
            -webkit-user-drag: none;
          }

          .txt {
            font-size: 24px;
            font-weight: 700;
            margin-left: 20px;
          }
        }

        p {
          margin-left: 30px;
          font-size: 16px;
          font-weight: 500;
          line-height: 32px;
        }

        .OpenImmediae {
          width: 119px;
          height: 40px;
          border-radius: 40px;
          background-color: #ff9900;
          color: #000;
          text-align: center;
          line-height: 40px;
          font-size: 14px;
          font-weight: 500;
          margin-left: 30px;
          margin-top: 30px;
          cursor: pointer;

          span {
            color: #fff;
            font-size: 16px;
            margin-left: 5px;
            font-weight: 700;
          }
        }
      }
    }

    .helpCenter {
      width: 100%;
      height: 500px;
      background-color: rgb(29 33 41);
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #fff;

      .helpCenterTitle {
        h1 {
          font-size: 3rem;
          font-weight: 700;
          color: aliceblue;
          text-align: center;
        }

        p {
          font-size: 1.125rem;
          font-weight: 500;
          color: aliceblue;
          margin-top: 30px;
          text-align: center;
          margin-bottom: 60px;
        }
      }

      .helpCenterContentTitle {
        font-weight: 500;
      }

      .helpCenterContent {
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
        box-sizing: border-box;
        position: relative;

        .code {
          position: absolute;
          top: -120px;
          left: 60px;
          background-image: url('../assets/member/layerBgpng.png');
          background-repeat: no-repeat;
          padding: 20px;
          border-radius: 10px;
          margin-right: 10px;

          &:last-child {
            margin-right: 0;
          }

          img {
            display: block;
            width: 70px;
            margin: 0 auto;
            padding-top: 6px;
          }

          p {
            font-size: 14px;
            color: #969696;
            padding: 6px 7px;
            text-align: center;
            white-space: nowrap;
          }
        }

        .code_1 {
          position: absolute;
          top: -120px;
          left: 300px;
          background-image: url('../assets/member/layerBgpng.png');
          background-repeat: no-repeat;
          padding: 22px;
          border-radius: 10px;
          margin-right: 10px;

          &:last-child {
            margin-right: 0;
          }

          img {
            display: block;
            width: 70px;
            margin: 0 auto;
            padding-top: 6px;
          }

          p {
            font-size: 14px;
            color: #969696;
            padding: 6px 7px;
            text-align: center;
            white-space: nowrap;
          }
        }

        .helpCenterContentBox {
          width: 240px;
          height: 200px;
          background-color: #ffffff14;
          border-radius: 24px;
          border: 1px solid #ffffff29;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-top: 50px;
          box-sizing: border-box;
          margin-top: 50px;
          margin-right: 20px;

          .ipt img {
            margin-bottom: 20px;
            -webkit-user-drag: none;
          }

          p {
            font-size: 24px;
            font-weight: 700;
          }
        }
      }
    }

    .usualQuest {
      height: 900px;
      background-color: rgb(29 33 41);
      color: #fff;

      .usualQuestTitle {
        width: 64.5rem;
        height: 6.875rem;
        margin: 0 auto;
        border-bottom: 1px solid #a6a6a6;
        margin-bottom: 3.125rem;

        h1 {
          font-size: 3rem;
          font-weight: 700;
          color: aliceblue;
          text-align: center;
        }

        p {
          font-size: 30px;
          font-weight: 700;
          color: #a6a6a6;
          margin-top: 10px;
          text-align: center;
          margin-bottom: 60px;
        }
      }

      .usualQuestContent {
        width: 64rem;
        margin: 0 auto;
        font-size: 1.125rem;
        font-weight: 500;
        line-height: 1.875rem;
        color: #fff;
        // margin-left: 18.9rem;

        a {
          color: #ff9900;
          border-bottom: 1px solid #ff9900;
          cursor: pointer;
        }
      }
    }
  }
}

/deep/.el-input__inner {
  border: none;
  background-color: #ffffff1a;
  border-radius: 0.75rem;
  height: 3.25rem;
  color: aliceblue;
  font-size: 1rem;
}

/deep/.el-form-item__error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 20px;
}

/deep/.el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 16px;
  color: #fff;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>